import { BaseService } from "../../Base/BaseService";

export type MasterLandingSpecialization = "manicure" | "brows-lashes" | "other" | "";

export interface IMasterLandingLeadPayload {
  name: string;
  contact: string;
  source: "master_landing";
}

export interface IMasterLandingLeadResponse {
  success: boolean;
  id?: number;
}

export class MasterLandingService extends BaseService {
  public static async SubmitLead(payload: IMasterLandingLeadPayload): Promise<IMasterLandingLeadResponse> {
    return await BaseService.post<IMasterLandingLeadResponse>(this.BaseApiUrl + "/master-leads", payload);
  }
}
